export var NOTIFICATION_DATE_FORMAT = 'dd MMM HH:mm';
export var NOTIFICATIONS_PER_PAGE = 10;
